export const SettingsNavKeys = {
  General: "general",
  Accounting: "accounting",
  Display: "display",
};
